import * as React from 'react';

import Report16 from './Report16';

export const report16 = () => <Report16 />;

export default {
    title: 'Icon|Line|Report16',
    component: Report16,
    parameters: {
        notes: "`import Report16 from 'box-ui-elements/es/icon/line/Report16';`",
    },
};
